import { Component, Input, OnInit } from '@angular/core';
import { EventRepeaterService } from 'src/app/services/event-repeater.service';
import { Event } from 'src/app/model/event';

@Component({
  selector: 'calendar',
  templateUrl: 'calendar.html',
  styleUrls: ["calendar.css"]
})

export class CalendarComponent implements OnInit {
  @Input("header") header: string;
  events: Event[] = [];
  firstDay: Date;
  private daysOfWeek: string[] = ["Mo", "Di", "Mi", "Do", "Fr", "Sa", "So"];
  private daysOfMonth: number[] = [];
  private eventsOfDay: Map<number, Event[]> = new Map<number, Event[]>();
  private eventsPerWeek: number[] = [];
  
  constructor(
    private readonly eventRepeaterService: EventRepeaterService
  ) { }

  ngOnInit(): void {
    this.firstDay = localStorage.getItem("eventDate") ? new Date(localStorage.getItem("eventDate")) : new Date();
    localStorage.removeItem("eventDate");
    this.firstDay.setDate(1);

    this.eventRepeaterService.getEvents().subscribe(events => {
      this.events = events;
      this.initCalendar();
    });
  }

  initCalendar(): void {
    let start: number = this.firstDay.getDay();
    // set sunday to last day of the week
    start = start === 0 ? 7 : start;
    start = 2 - start;

    // get last day of month
    let lastDay: Date = new Date(this.firstDay);
    lastDay.setMonth(lastDay.getMonth() + 1);
    lastDay.setDate(0);
    let end: number = lastDay.getDate();

    this.daysOfMonth = [];
    for(let day: number = start; day <= end; day++) {
      this.daysOfMonth.push(day);
      if (day > 0) {
        this.eventsOfDay.set(day, this.getEventsFromDay(day));
      }
    }
  }

  private getEventsFromDay(day: number): Event[] {
    let date = this.createDate(this.firstDay);
    date.setDate(day);
    return this.events.filter(event => this.createDate(event.date).getTime() === date.getTime());
  }

  private prevMonth() {
    this.incrementMonth(-1);
  }

  private nextMonth() {
    this.incrementMonth(1);
  }

  private currentMonth() {
    this.firstDay = new Date();
    this.firstDay.setDate(1);
    this.initCalendar();
  }

  private incrementMonth(increment: number) {
    this.firstDay = new Date(this.firstDay.getFullYear(), this.firstDay.getMonth() + increment, this.firstDay.getDate());
    this.initCalendar();
  }

  private createDate(dateString: Date) {
    let date = new Date(dateString);
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  }
}